var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540 541 c0 -6 5 -13 10 -16 17 -10 11 -25 -9 -25 -10 0 -22 -7 -25 -16 -9 -24 14 -46 41 -41 26 5 27 3 12 -24 -10 -19 -12 -19 -49 15 -45 41 -85 50 -181 44 -64 -5 -70 -4 -84 18 -9 15 -25 24 -40 24 -21 0 -25 -5 -25 -29 0 -34 -78 -123 -123 -140 -24 -9 -27 -16 -27 -56 0 -45 0 -45 60 -75 46 -23 61 -36 66 -58 12 -60 22 -72 58 -72 35 0 46 12 46 51 0 18 6 20 67 17 66 -3 67 -3 75 -36 8 -29 12 -32 47 -32 44 0 62 16 90 80 26 62 34 121 22 165 -9 32 -7 41 12 66 19 27 20 33 8 76 -12 48 -27 73 -42 73 -5 0 -9 -4 -9 -9z m22 -73 c-9 -9 -15 -9 -24 0 -9 9 -7 12 12 12 19 0 21 -3 12 -12z m-364 -119 c-2 -6 -8 -10 -13 -10 -5 0 -11 4 -13 10 -2 6 4 11 13 11 9 0 15 -5 13 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPig);
export default __webpack_public_path__ + "static/media/pig.2c3e9a87053e3259b1ffeecaa374daaf.svg";
export { ForwardRef as ReactComponent };